import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ChartOfAccountsTemplateRow } from "../chartOfAccountsTemplatesViewConfig";

export const ChartOfAccountsTemplateChartCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, ChartOfAccountsTemplateRow, unknown>) => (
        <ViewTableCell>
            <span>
                {row.original.hasCustomChartOfAccounts ? "Custom" : "Kick"}
            </span>
        </ViewTableCell>
    ),
);
